import api from "utils/api";
import { useSearchParamState } from "hooks/useSearchParamState";
import { useInfiniteLocalPaginatedRequest } from "hooks/useInfiniteLocalPaginatedRequest";
import { DEFAULT_ITEMS_PER_PAGE } from "./constants";
import { UseDocumentationsPageArgs } from "./types";

export const useDocumentationsPage = ({
  projectId,
  itemsPerPage = DEFAULT_ITEMS_PER_PAGE,
}: UseDocumentationsPageArgs) => {
  const [statusFilter, setStatusFilter] = useSearchParamState<string>({
    key: "status",
    defaultValue: "all",
    parse: (val) => val,
    serialize: (val) => (val === "all" ? "" : val),
  });

  const [searchTerm, setSearchTerm] = useSearchParamState<string>({
    key: "search",
    defaultValue: "",
    parse: (val) => val,
    serialize: (val) => val,
  });

  const { items, isLoading, error, onLoadMore, canLoadMore, resetList } =
    useInfiniteLocalPaginatedRequest({
      defaultPage: 1,
      defaultLimit: itemsPerPage,
      resetDeps: [projectId, statusFilter, searchTerm],
      service: async ({ page, limit }) => {
        const result = await api.getDocumentationByProject(projectId, {
          page,
          limit,
          ...(statusFilter === "all" ? {} : { status: statusFilter }),
          ...(searchTerm ? { search: searchTerm } : {}),
        });

        return {
          items: result.documentations,
          pagination: result.pagination,
        };
      },
    });

  return {
    data: items,
    isLoading,
    error,

    statusFilter,
    searchTerm,
    setStatusFilter,
    setSearchTerm,

    onLoadMore,
    canLoadMore,
    resetList,
  };
};
